/* eslint-disable @typescript-eslint/no-unsafe-assignment */
'use client'
import Cookies from 'universal-cookie'
import SessionInfoContent from './SessionInfoContent'
import { ApiRouteNames, useApi } from '@/api'
import { BETTERPLACE_SESSION_COOKIE_NAME } from '@/constants'
const cookies = new Cookies()
function SessionInfo() {
  const { data, isLoading } = useApi(
    ApiRouteNames.apiCurrentUser,
    {},
    {
      pathNameOnly: true,
      fetchOptions: {
        headers: { cookie: cookies.get(BETTERPLACE_SESSION_COOKIE_NAME) },
      },
    }
  )
  const user = data?.user ?? null
  return <SessionInfoContent user={user} loading={isLoading} />
}

export default SessionInfo
